/** @format */

import { Box, Button, Text } from "@chakra-ui/react";
import { useEffect, useMemo, useState } from "react";
import { useHistory } from "react-router-dom";
import { removeAcento } from "../../../utils";
import { LojaButton } from "../../../components/LojaButton";
import { Lojas } from "../Lojas";
import { useRecomendacao } from "../../../context/useRecomendacao";
import { Header } from "../../../components/Header";
import { CardOfertaHorizontal } from "../../../components/CardOferta/Horizontal";
import { CardCashbackHorizontal } from "../../../components/CardCashback/Horizontal";
import { CardDescontoExclusivoHorizontal } from "../../../components/CardDescontoExclusivo/Horizontal";
import { usePersonalizacao } from "../../../context/usePersonalizacao";
import { FiltrosList } from "../../../components/FiltrosList";

export function Pesquisa() {
  const history = useHistory();
  const {
    recomendacao,
    filteredRecomendacao,
    inputSearch,
    setInputSearch,
    loja,
    selectedFiltros,
    requestRecomendacao,
    viewDescricao,
  } = useRecomendacao();
  const {
    personalizacao: { guiaofertas },
  } = usePersonalizacao();

  const [isModalLojaOpen, setIsModalLojaOpen] = useState(false);

  const produtos =
    selectedFiltros.length > 0 ? filteredRecomendacao : recomendacao;
  const [productsFound, setProductsFound] = useState([]);
  const [page, setPage] = useState(5);

  useEffect(() => {
    setInputSearch("");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (recomendacao.length > 0) {
      return;
    } else {
      requestRecomendacao();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (inputSearch.length >= 2) {
      let text = removeAcento(inputSearch.toUpperCase());
      let filteredData = produtos.filter((item, index) => {
        let itemName = item.produto
          ? item.produto.toUpperCase()
          : item.nomeoferta.toUpperCase();
        itemName = removeAcento(itemName);

        return itemName.indexOf(text) > -1;
      });
      setProductsFound(filteredData);
    } else {
      setProductsFound([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inputSearch, selectedFiltros]);

  const loadMoreProducts = () => {
    setPage(page + 8);
  };

  const ProdutosView = () =>
    useMemo(() => {
      return (
        <Box paddingX="1rem">
          {productsFound.slice(0, page).map((data) => (
            <Box key={data.idoferta}>
              {data.idtiporecomendacao === "2" && (
                <Box marginY="1.5rem">
                  <CardOfertaHorizontal
                    onClickCard={
                      !data.linkproduto
                        ? () => {
                            history.push(`/descricao/2/${data.idoferta}`);
                            viewDescricao(data);
                          }
                        : () => {
                            window.ReactNativeWebView.postMessage(JSON.stringify({title: data.nomeoferta.slice(0, 30), url: data.linkproduto}));
                            viewDescricao(data);
                          }
                    }
                    props={data}
                  />
                </Box>
              )}
              {data.idtiporecomendacao === "1" && (
                <Box key={data.idoferta} marginY="1.5rem">
                  <CardDescontoExclusivoHorizontal
                    onClickCard={
                      !data.linkproduto
                        ? () => {
                            history.push(`/descricao/1/${data.idoferta}`);
                            viewDescricao(data);
                          }
                        : () => {
                            window.ReactNativeWebView.postMessage(JSON.stringify({title: data.nomeoferta.slice(0, 30), url: data.linkproduto}));
                            viewDescricao(data);
                          }
                    }
                    props={data}
                  />
                </Box>
              )}
              {data.idtiporecomendacao === "3" && (
                <Box key={data.idoferta} marginY="1.5rem">
                  <CardCashbackHorizontal
                    onClickCard={
                      !data.linkproduto
                        ? () => {
                            history.push(`/descricao/3/${data.idoferta}`);
                            viewDescricao(data);
                          }
                        : () => {
                            window.ReactNativeWebView.postMessage(JSON.stringify({title: data.nomeoferta.slice(0, 30), url: data.linkproduto}));
                            viewDescricao(data);
                          }
                    }
                    props={data}
                  />
                </Box>
              )}
            </Box>
          ))}
        </Box>
      );
    }, []);

  return (
    <Box maxWidth="900px" margin="0 auto" background="white" overflow="hidden">
      <Box
        background={guiaofertas.headerbackground}
        w="100%"
        maxWidth="900px"
        position="fixed"
        zIndex="sticky"
        paddingTop="0.5rem"
      >
        <Box paddingX="1rem">
          <Header />

          <Box my="0.25rem" mx="-1rem">
            <FiltrosList />
          </Box>
          <Box my="0.75rem">
            <LojaButton
              loja={loja.nomeLojaSelecionada || "Selecione uma loja"}
              onClick={() => setIsModalLojaOpen(true)}
            />
            <Lojas
              isOpen={isModalLojaOpen}
              onRequestClose={() => setIsModalLojaOpen(false)}
            />
          </Box>
        </Box>
      </Box>
      <Box
        display="flex"
        flexDir="column"
        minHeight="calc(100vh)"
        background={guiaofertas.background !== undefined ? (guiaofertas.background ? guiaofertas.background : "#EDEEF2") : "#EDEEF2"}
        paddingTop="12.5rem"
      >
        <Box
          padding="0rem"
          height="100%"
          overflowY="hidden"
          overflowX="hidden"
          display="flex"
          flexDir="column"
        >
          <Text marginLeft="1rem" color="#555861" fontSize="sm">{`${
            productsFound.length
          } ${
            productsFound.length > 1 || productsFound.length === 0
              ? "ofertas encontradas"
              : "oferta encontrada"
          } `}</Text>
          <ProdutosView />
        </Box>
        {productsFound.length >= page && (
          <Button
            type="button"
            padding="1rem"
            margin="1rem"
            background="transparent"
            onClick={loadMoreProducts}
          >
            Carregar mais
          </Button>
        )}
      </Box>
    </Box>
  );
}
